import { IState } from '../../store';

export const selectOfferChatId = (state: IState): string | null => {
  return state.offerChat.chatId || null;
};
